import type { ReactNode } from 'react';

export const symbol_magnification_small: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Zm191-331q23-23 23-56t-23-56q-23-23-56-23t-56 23q-23 23-23 56t23 56q23 23 56 23t56-23Z"
		/>
	</svg>
);
